import { BlockAttributes } from '../types/wordpress';

/**
 * Standard WordPress content widths
 */
export const CONTENT_WIDTHS = {
  DEFAULT: 1200,      // Standard content width
  WIDE: 1400,         // Wide content width (alignwide)
  FULL: 1920,         // Full width (alignfull) reference
  MIN_DESKTOP: 1024,  // Minimum desktop viewport width
} as const;

/**
 * Default block spacing values
 */
export const BLOCK_SPACING = {
  GAP: '2rem',        // Default block gap
  COLUMN_GAP: '2rem', // Default column gap
  PADDING: '2rem',    // Default block padding
  MARGIN: '2rem',     // Default block margin
} as const;

/**
 * Block relationship mappings
 */
export const BLOCK_RELATIONSHIPS = {
  NAVIGATION: {
    PARENT: 'core/navigation',
    CHILDREN: [
      'core/navigation-link',
      'core/navigation-submenu',
      'core/search',
      'core/social-links',
      'core/page-list',
      'core/spacer',
      'core/home-link',
      'core/site-title',
      'core/site-logo',
      'core/loginout',
      'core/buttons'
    ]
  },
  BUTTONS: {
    PARENT: 'core/buttons',
    CHILDREN: ['core/button']
  },
  COMMENTS: {
    PARENT: 'core/comments',
    CHILDREN: [
      'core/comment-template',
      'core/comments-title',
      'core/comments-pagination'
    ],
    PAGINATION: {
      PARENT: 'core/comments-pagination',
      CHILDREN: [
        'core/comments-pagination-numbers',
        'core/comments-pagination-previous',
        'core/comments-pagination-next'
      ]
    }
  },
  QUERY: {
    PARENT: 'core/query',
    CHILDREN: [
      'core/post-template',
      'core/query-pagination',
      'core/query-no-results'
    ],
    PAGINATION: {
      PARENT: 'core/query-pagination',
      CHILDREN: [
        'core/query-pagination-numbers',
        'core/query-pagination-previous',
        'core/query-pagination-next'
      ]
    }
  }
} as const;

/**
 * Common block attributes
 */
export const COMMON_ATTRIBUTES: Partial<BlockAttributes> = {
  align: {
    type: 'string',
    enum: ['left', 'center', 'right', 'wide', 'full']
  },
  anchor: {
    type: 'string'
  },
  className: {
    type: 'string'
  }
} as const;

/**
 * Common block supports
 */
export const COMMON_SUPPORTS = {
  anchor: true,
  html: false,
  className: true,
  typography: {
    fontSize: true,
    lineHeight: true,
    fontFamily: true,
    fontWeight: true,
    fontStyle: true,
    textTransform: true,
    textDecoration: true,
    letterSpacing: true
  },
  spacing: {
    margin: true,
    padding: true,
    blockGap: true
  },
  color: {
    text: true,
    background: true,
    gradients: true,
    link: true
  },
  border: {
    color: true,
    radius: true,
    style: true,
    width: true
  }
} as const;